import React from 'react';
import { useTranslation } from 'react-i18next';
import { Placeholder } from '../Placeholder';
import { useFromToContext } from '../../../shared';
import { DateFromTo, TopProductsComponent } from '../../../../generated/graphql';
import { routePaths } from '../../../../routePaths';
import ProductsView from './ProductsView';

const TopProductsList = () => {
    const { t } = useTranslation();
    const { dateFromTo } = useFromToContext();

    const linkUrl = routePaths.reportsProducts;
    return (
        <TopProductsComponent
            variables={{ dateFromTo: dateFromTo as DateFromTo }}
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={351} />}
        >
            {({ data: { topProducts } }) => (
                <ProductsView
                    itemsPerRow={5}
                    title={t('Top 5 product sales')}
                    products={topProducts}
                    linkUrl={linkUrl}
                />
            )}
        </TopProductsComponent>
    );
};
export default TopProductsList;